var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLayer1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42.7,
    height: 42.7,
    viewBox: "0 0 42.7 42.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(-0.529 -280.596)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path33289",
    d: "M21.879,280.6a21.282,21.282,0,0,0-8.815,1.9.712.712,0,0,0-.342.967l1.272,2.548a.712.712,0,0,0,.93.331,17.072,17.072,0,0,1,21.087,25.175l-2.243-2.245a.71.71,0,0,0-1.213.5V317.6a.712.712,0,0,0,.709.714H41.09a.712.712,0,0,0,.5-1.219l-2.523-2.523A21.327,21.327,0,0,0,21.879,280.6Zm-19.218,4.98a.712.712,0,0,0-.5,1.214l2.524,2.524a21.347,21.347,0,0,0,26.014,32.081.712.712,0,0,0,.341-.967l-1.276-2.548a.712.712,0,0,0-.924-.331,17.077,17.077,0,0,1-21.1-25.173l2.252,2.246a.712.712,0,0,0,1.213-.5v-7.827a.712.712,0,0,0-.714-.714Zm19.217,4.982a11.387,11.387,0,1,0,11.39,11.39,11.4,11.4,0,0,0-11.39-11.39Zm0,2.843a.683.683,0,0,1,.712.712v1.508a3.569,3.569,0,0,1,2.848,3.485.712.712,0,1,1-1.423,0,2.133,2.133,0,1,0-2.134,2.134,3.56,3.56,0,0,1,.709,7.047v1.494a.712.712,0,1,1-1.423,0v-1.5a3.569,3.569,0,0,1-2.841-3.485.712.712,0,0,1,1.423,0,2.133,2.133,0,1,0,2.132-2.138,3.556,3.556,0,0,1-.714-7.04v-1.51a.684.684,0,0,1,.712-.712Z",
    fill: "#4e3057"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLayer1);
export default __webpack_public_path__ + "static/media/layer1.d3dffd1a9b03acaf462ed71afb64cc0c.svg";
export { ForwardRef as ReactComponent };